import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Container, Navbar, Nav } from 'react-bootstrap'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const MenuWrapper = styled.div`
  position: absolute;
  width: 150px;
  top: 100%;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  @media (max-width: 575px) {
    width: 100px;
  }
`

const NavDecoLine = styled(motion.div)`
  position: absolute;
  z-index: 1002;
  border-bottom: 4px solid var(--bs-blue);
  width: 100%;
  bottom: 0px;
  transform-origin: center;
`

export const Header = () => {
  const [companyMenuVisible, setCompanyMenuVisible] = useState(false) // 회사소개 세부메뉴
  const [businessMenuVisible, setBusinessMenuVisible] = useState(false) // 사업소개 세부메뉴
  const [galleryMenuVisible, setGalleryMenuVisible] = useState(false)
  const location = useLocation()

  const companyItems = [
    { path: '/company/greetings', label: '인사말' },
    { path: '/company/history', label: '연혁' },
    { path: '/company/license', label: '면허보유현황' },
    { path: '/company/vision', label: '비전 및 미션' },
    { path: '/company/map', label: '찾아오시는 길' },
  ]

  const businessItems = [
    { path: '/business/facility', label: '시설개요' },
    { path: '/business/distribution', label: '물류 시설 현황' },
    { path: '/business/equipment', label: '장비 현황' },
  ]

  useEffect(() => {
    setCompanyMenuVisible(false)
    setBusinessMenuVisible(false)
  }, [location])

  return (
    <header style={{ position: 'sticky', top: '0', zIndex: '1001' }}>
      <Navbar id="main-nav" className="bg-white">
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <img src="/logo/logo.png" alt="서진로지텍" width={75} />
            <div id="company-name-wrapper">
              <h1 id="company-name">㈜ 서진로지텍</h1>
              <span id="company-name-eng">Seojin Logitech</span>
            </div>
          </Navbar.Brand>
          <Nav className="ms-auto text-center">
            <div
              onMouseEnter={() => setCompanyMenuVisible(true)}
              onMouseLeave={() => setCompanyMenuVisible(false)}
              style={{ position: 'relative' }}
            >
              <Nav.Link
                as={Link}
                to="/company/greetings"
                className={`header-nav-link ${
                  companyMenuVisible ? 'hover-nav-link' : ''
                }`}
              >
                회사소개
              </Nav.Link>
              <NavDecoLine
                isVisible={companyMenuVisible}
                initial={{ scaleX: 0 }}
                animate={companyMenuVisible ? { scaleX: 1 } : { scaleX: 0 }}
                transition={{ duration: 0.3 }}
              />
              <MenuWrapper isVisible={companyMenuVisible}>
                <div
                  style={{ height: '10px', backgroundColor: 'transparent' }}
                />
                <div className="nav-expanded">
                  {companyItems.map((item) => (
                    <Link key={item.path} to={item.path}>
                      <h6 className="nav-expanded-menu">{item.label}</h6>
                    </Link>
                  ))}
                </div>
              </MenuWrapper>
            </div>
            <div
              onMouseEnter={() => setBusinessMenuVisible(true)}
              onMouseLeave={() => setBusinessMenuVisible(false)}
              style={{ position: 'relative' }}
            >
              <Nav.Link
                as={Link}
                to="/business/facility"
                className={`header-nav-link ${
                  businessMenuVisible ? 'hover-nav-link' : ''
                }`}
              >
                사업소개
              </Nav.Link>
              <NavDecoLine
                isVisible={businessMenuVisible}
                initial={{ scaleX: 0 }}
                animate={businessMenuVisible ? { scaleX: 1 } : { scaleX: 0 }}
                transition={{ duration: 0.3 }}
              />
              <MenuWrapper isVisible={businessMenuVisible}>
                <div
                  style={{ height: '10px', backgroundColor: 'transparent' }}
                />
                <div className="nav-expanded">
                  {businessItems.map((item) => (
                    <Link key={item.path} to={item.path}>
                      <h6 className="nav-expanded-menu">{item.label}</h6>
                    </Link>
                  ))}
                </div>
              </MenuWrapper>
            </div>
            {/* 새로 추가 */}
            <div
              onMouseEnter={() => setGalleryMenuVisible(true)}
              onMouseLeave={() => setGalleryMenuVisible(false)}
              style={{ position: 'relative' }}
            >
              <Nav.Link
                as={Link}
                to="/gallery/gallery"
                className={`header-nav-link ${
                  galleryMenuVisible ? 'hover-nav-link' : ''
                }`}
              >
                갤러리
              </Nav.Link>
              <NavDecoLine
                isVisible={galleryMenuVisible}
                initial={{ scaleX: 0 }}
                animate={galleryMenuVisible ? { scaleX: 1 } : { scaleX: 0 }}
                transition={{ duration: 0.3 }}
              />
            </div>
          </Nav>
        </Container>
      </Navbar>
    </header>
  )
}
